import Black from '../../assets/puntgenie/fonts/Roboto-Black.ttf';
import BlackItalic from '../../assets/puntgenie/fonts/Roboto-BlackItalic.ttf';
import Bold from '../../assets/puntgenie/fonts/Roboto-Bold.ttf';
import BoldItalic from '../../assets/puntgenie/fonts/Roboto-BoldItalic.ttf';

import ExtraLight from '../../assets/puntgenie/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '../../assets/puntgenie/fonts/Roboto-ThinItalic.ttf';
import Light from '../../assets/puntgenie/fonts/Roboto-Light.ttf';
import LightItalic from '../../assets/puntgenie/fonts/Roboto-LightItalic.ttf';
import Regular from '../../assets/puntgenie/fonts/Roboto-Regular.ttf';
import Italic from '../../assets/puntgenie/fonts/Roboto-Italic.ttf';
import SemiBold from '../../assets/puntgenie/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '../../assets/puntgenie/fonts/Roboto-MediumItalic.ttf';

import CinzelDecorative from '../../assets/puntgenie/fonts/CinzelDecorative-Regular.ttf';
import CinzelDecorativeBold from '../../assets/puntgenie/fonts/CinzelDecorative-Bold.ttf';
import CinzelDecorativeBlack from '../../assets/puntgenie/fonts/CinzelDecorative-Black.ttf';

export const fontFace = `
  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLight}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 100;
    font-display: swap;
    src: url('${ExtraLightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${Light}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 300;
    font-display: swap;
    src: url('${LightItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${Regular}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${Italic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url('${SemiBoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${Bold}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url('${BoldItalic}') format('opentype');
  }

  @font-face {
    font-family: 'roboto';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${Black}') format('opentype');
  }
  @font-face {
    font-family: 'roboto';
    font-style: italic;
    font-weight: 900;
    font-display: swap;
    src: url('${BlackItalic}') format('opentype');
  }

  @font-face {
    font-family: 'CinzelDecorative';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${CinzelDecorative}') format('opentype');
  }

  @font-face {
    font-family: 'CinzelDecorative';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${CinzelDecorativeBold}') format('opentype');
  }

  @font-face {
    font-family: 'CinzelDecorative';
    font-style: normal;
    font-weight: 900;
    font-display: swap;
    src: url('${CinzelDecorativeBlack}') format('opentype');
  }
`;
